
import React from "react";
import CourseUsersTable from "../../../components/Tables/CourseUsersTable";
import { useCourseContext } from "../../../contexts/CoursesContext";

export const CourseUsers = ({ style = {} }) => {
  const { courseUsers, setCourseUsers } = useCourseContext();
  return (
    <div style={{ width: "100%", position: "relative", ...style }}>
      <CourseUsersTable users={courseUsers}
        onUpdated={(newUsers) => {
          const updatedUsers = [...courseUsers];
          newUsers.forEach((newUser) => {
            const index = updatedUsers.findIndex((u) => u.public_id === newUser.public_id);
            if (index !== -1) {
              updatedUsers[index] = newUser;
            } else {
              updatedUsers.push(newUser);
            }
          });

          setCourseUsers(updatedUsers);
        }}
      />
    </div >
  );
};

export default CourseUsers;
